import { format } from 'date-fns';
import type { CampaignStatus, RecipientStatus } from '../../functions/src/shared/types';

/** Firestore Timestamps arrive as objects with a toDate(); nulls are common mid-write. */
export function formatTimestamp(value: unknown): string {
  if (!value) return '—';
  const candidate = value as { toDate?: () => Date };
  if (typeof candidate.toDate !== 'function') return '—';
  try {
    return format(candidate.toDate(), 'MMM d, yyyy h:mm a');
  } catch {
    return '—';
  }
}

type ChipColor = 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info';

export function statusColor(status: CampaignStatus): ChipColor {
  switch (status) {
    case 'sending':
      return 'primary';
    case 'completed':
      return 'success';
    case 'paused':
      return 'warning';
    case 'failed':
      return 'error';
    case 'canceled':
      return 'default';
    default:
      return 'info';
  }
}

export function recipientStatusColor(status: RecipientStatus): ChipColor {
  switch (status) {
    case 'sent':
      return 'success';
    case 'sending':
      return 'primary';
    case 'queued':
      return 'info';
    case 'suppressed':
      return 'default';
    case 'failed':
    case 'bounced':
    case 'complained':
      return 'error';
    default:
      return 'default';
  }
}
